import { formatArgsToHttpText } from '../../HITL/utils/http-formatters';

export type HttpHitlDisplayArgs = {
  method: string;
  url: string;
  statusCode?: number;
  rawResult?: string;
  headers?: Record<string, string | string[]>;
  body?: string;
  formData?: string;
  wasProxyModified?: boolean;
};

export function buildHttpHitlRequestPayload(
  args: Record<string, unknown>,
): string | undefined {
  const url = typeof args.url === 'string' ? args.url : undefined;
  const method = typeof args.method === 'string' ? args.method : 'GET';

  if (!url) {
    return undefined;
  }

  const rawHeaders =
    args.headers &&
    typeof args.headers === 'object' &&
    !Array.isArray(args.headers)
      ? (args.headers as Record<string, string | string[]>)
      : undefined;

  const body =
    typeof args.body === 'string' && args.body ? args.body : undefined;
  const formData =
    typeof args.formData === 'string' && args.formData
      ? args.formData
      : undefined;

  return formatArgsToHttpText({
    url,
    method,
    headers: rawHeaders,
    body: body ?? formData,
  });
}

export function buildHttpHitlResponsePayload(
  args: Record<string, unknown>,
): string | undefined {
  const statusCode =
    typeof args.statusCode === 'number' ? args.statusCode : undefined;
  const rawResult =
    typeof args.rawResult === 'string' && args.rawResult.trim()
      ? args.rawResult
      : undefined;

  if (statusCode === undefined && !rawResult) {
    return undefined;
  }

  const statusLine = `HTTP/1.1 ${statusCode ?? ''}`.trim();

  return rawResult ? `${statusLine}\n\n${rawResult}` : statusLine;
}
